module.exports = __webpack_public_path__ + "img/img_shouxinchongshenka1@2x.9fe6f2fc.png";